import React, { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';

import { UserContext } from '~/components/providers/UserProvider';
import { Routes } from '~/domains/common/constants/routes';

function withTaxInformation<P extends { onClose?: VoidFunction; isOpen?: boolean }>(
  WrappedComponent: React.ComponentType<P>
) {
  function WithTaxInformation(props: P) {
    const { isOpen = true, onClose } = props;
    const { w9Blocked } = useContext(UserContext);
    const router = useRouter();

    useEffect(() => {
      if (w9Blocked && isOpen) {
        onClose?.();
        router.replace(Routes.withdrawTaxInformation());
      }
    }, [w9Blocked, isOpen, onClose, router]);

    if (w9Blocked) return null;

    return <WrappedComponent {...props} />;
  }

  WithTaxInformation.displayName = `withTaxInformation(${WrappedComponent.displayName ?? WrappedComponent.name})`;

  return WithTaxInformation;
}

export default withTaxInformation;
